var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.003 512.003",
    style: {
      enableBackground: "new 0 0 512.003 512.003"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D3C8"
    },
    d: "M98.869,512h292.025V85.037H98.869V512z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.732,
    y: 85.037,
    style: {
      fill: "#D7D3C8"
    },
    width: 135.164,
    height: 426.966
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.987,
    y: 299.878,
    style: {
      fill: "#28182A"
    },
    width: 195.796,
    height: 30.021
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.987,
    y: 353.275,
    style: {
      fill: "#28182A"
    },
    width: 195.796,
    height: 30.021
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.987,
    y: 406.672,
    style: {
      fill: "#28182A"
    },
    width: 195.796,
    height: 30.021
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 255.732,
    y: 299.878,
    style: {
      fill: "#28182A"
    },
    width: 87.047,
    height: 30.021
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.732,
    y: 406.672,
    style: {
      fill: "#28182A"
    },
    width: 87.047,
    height: 30.021
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.732,
    y: 353.275,
    style: {
      fill: "#28182A"
    },
    width: 87.047,
    height: 30.021
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28182A"
    },
    d: "M143.957,213.427c0-29.044,22.289-49.442,52.684-49.442c18.508,0,33.097,6.755,42.418,18.912 l-20.128,17.966c-5.539-7.025-12.157-11.078-20.668-11.078c-13.238,0-22.154,9.186-22.154,23.64s8.916,23.64,22.154,23.64 c8.511,0,15.13-4.053,20.668-11.078l20.128,17.966c-9.321,12.157-23.911,18.912-42.418,18.912 C166.246,262.869,143.957,242.471,143.957,213.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28182A"
    },
    d: "M349.293,166.146l-39.986,94.562h-31.341l-39.987-94.562h34.312l22.56,55.251l23.101-55.251H349.293 z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#28182A"
    },
    points: "317.953,166.146 294.853,221.398 272.293,166.146 255.732,166.146 255.732,208.127  277.967,260.708 309.308,260.708 349.293,166.146 "
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.0d140324002b68943be726e2f2d8388f.svg";
export { ForwardRef as ReactComponent };